import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPendingConfiguration || _vm.isDraft)?_c('div',{class:[
    'info-box',
    _vm.isDraft && _vm.hasPendingConfiguration && 'info-box--type-warning',
    _vm.isDraft && !_vm.hasPendingConfiguration && 'info-box--type-info',
    !_vm.isDraft && _vm.hasPendingConfiguration && 'info-box--type-warning'
  ]},[_c(VIcon,[_vm._v("vizartist_show_scene_info_editor")]),_c('span',[_vm._v(_vm._s(_vm.warningMessage))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }